export default __webpack_public_path__ + "static/media/hht2_ep05_timeline_05.ebb148d8.png";